/* Global imports. */
import React from "react";
import { Script } from "gatsby"

interface Props {
  html: string;
  title: string;
}

const InstagramEmbed = ({ html, title }: Props) => {
  return <>
  {title && <h2>{title}</h2>}
  <div className="twitter-embed" dangerouslySetInnerHTML={{ __html: html.replace('<script async src="//www.instagram.com/embed.js"></script>', '') }} /> 
  </>
}

export default InstagramEmbed;